import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KzFiltersComponent } from './kz-filters/kz-filters.component';
import { KzFilterItemComponent } from './kz-filter-item/kz-filter-item.component';
import { KzFilterInputComponent } from './kz-filter-input/kz-filter-input.component';
import { KzIconsModule } from '../icon/kz-icons.module';



@NgModule({
  imports: [
    CommonModule,
    KzIconsModule,
  ],
  declarations: [
    KzFiltersComponent,
    KzFilterItemComponent,
    KzFilterInputComponent,
  ],
  exports: [
    KzFiltersComponent,
    KzFilterItemComponent,
    KzFilterInputComponent,
  ]
})
export class KzFiltersModule { }
